module.exports = __webpack_public_path__ + "static/media/deskBackground.89847aa1.jpg";